import React, { useState } from 'react';
import reportService from '../../services/reportService';
import Toast from '../../components/Common/Toast';
import { formatDateLocaleLima } from '../../utils/dateUtils';

const RequirementTraceability = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  const load = async (e) => {
    e?.preventDefault();
    setLoading(true);
    try {
      const filters = {};
      if (code) filters.requirement_code = code;
      if (dateFrom) filters.date_from = dateFrom;
      if (dateTo) filters.date_to = dateTo;
      const res = await reportService.getRequirementTraceability(filters);
      if (res.success) {
        setData(res.data || []);
        if (!res.data?.length) {
          setToast({ isOpen: true, message: 'Sin resultados', type: 'info' });
        }
      }
    } catch {
      setToast({ isOpen: true, message: 'Error al cargar trazabilidad', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-800 mb-2">Trazabilidad de requerimientos</h1>
      <p className="text-gray-600 mb-6 text-sm">
        Cadena REQ → órdenes de compra, documentos y guías vinculadas.
      </p>

      <form onSubmit={load} className="flex flex-wrap gap-3 mb-6 items-end">
        <div>
          <label className="text-xs text-gray-600">Código REQ</label>
          <input
            value={code}
            onChange={(e) => setCode(e.target.value)}
            className="block border rounded-lg px-3 py-2"
            placeholder="REQ-0001"
          />
        </div>
        <div>
          <label className="text-xs text-gray-600">Desde</label>
          <input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} className="block border rounded-lg px-3 py-2" />
        </div>
        <div>
          <label className="text-xs text-gray-600">Hasta</label>
          <input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} className="block border rounded-lg px-3 py-2" />
        </div>
        <button type="submit" disabled={loading} className="px-4 py-2 bg-teal-600 text-white rounded-lg">
          {loading ? 'Buscando...' : 'Buscar'}
        </button>
      </form>

      <div className="space-y-6">
        {data.map((row) => (
          <div key={row.requirement.id} className="border rounded-xl p-5 bg-white shadow-sm">
            <h2 className="font-mono text-lg text-teal-700 font-semibold">{row.requirement.code}</h2>
            <p className="text-sm text-gray-600">
              Fecha: {formatDateLocaleLima(row.requirement.request_date)} · Estado: {row.requirement.status}
            </p>
            <div className="mt-4 grid md:grid-cols-3 gap-4 text-sm">
              <div>
                <h3 className="font-medium text-gray-800 mb-2">Órdenes de compra</h3>
                <ul className="list-disc pl-4 text-gray-600">
                  {(row.derivations?.purchase_orders || []).map((po) => (
                    <li key={po.id}>{po.code} {po.supplier?.name ? `· ${po.supplier.name}` : ''}</li>
                  ))}
                  {!row.derivations?.purchase_orders?.length && <li>—</li>}
                </ul>
              </div>
              <div>
                <h3 className="font-medium text-gray-800 mb-2">Documentos</h3>
                <ul className="list-disc pl-4 text-gray-600">
                  {(row.derivations?.documents || []).map((d) => (
                    <li key={d.id}>{d.code}</li>
                  ))}
                  {!row.derivations?.documents?.length && <li>—</li>}
                </ul>
              </div>
              <div>
                <h3 className="font-medium text-gray-800 mb-2">Guías</h3>
                <ul className="list-disc pl-4 text-gray-600">
                  {(row.derivations?.entry_guides || []).map((g) => (
                    <li key={g.id}>{g.code}</li>
                  ))}
                  {!row.derivations?.entry_guides?.length && <li>—</li>}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>

      <Toast isOpen={toast.isOpen} message={toast.message} type={toast.type} onClose={() => setToast({ ...toast, isOpen: false })} />
    </div>
  );
};

export default RequirementTraceability;


